export default {
  name: 'autofocus',
  inserted: function (el, _, vnode) {
    const component = vnode?.componentInstance;
    if (component?.focus) {
      component.focus();
      return;
    }
    el.focus();
  },
};
